"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const react_dock_1 = __importDefault(require("react-dock"));
const emotion_1 = require("emotion");
const hamburger_1 = require("./shapes/hamburger");
const colors_1 = require("./colors");
class Drawer extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.hideDrawer = () => {
            this.props.onRequestHide && this.props.onRequestHide();
        };
        // this is only called when clicking outside the drawer
        this.handleVisibleChange = () => {
            if (this.props.closeOnClickOutside) {
                this.hideDrawer();
            }
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.show) {
            document.body.className = document.body.className.replace(/ ?drawer-open/, '');
        }
        else if (this.props.show && !prevProps.show) {
            document.body.className += document.body.className.length ? ' drawer-open' : 'drawer-open';
        }
    }
    componentWillUnmount() {
        // clean up any open drawer classes from the body before unmounting the component
        document.body.className = document.body.className.replace(/ ?drawer-open/, '');
    }
    render() {
        const _a = this.props, { show, position, autoResize, size, header, footer, children, headerStyle, footerStyle, bodyStyle, style, className, zIndex } = _a, rest = __rest(_a, ["show", "position", "autoResize", "size", "header", "footer", "children", "headerStyle", "footerStyle", "bodyStyle", "style", "className", "zIndex"]);
        let customHeader;
        if (header) {
            customHeader = react_1.default.isValidElement(header) ? header : react_1.default.createElement("h2", null, header);
        }
        const drawerHeader = (react_1.default.createElement("div", { className: "drawer-header", style: headerStyle },
            react_1.default.createElement("button", { className: "close", onClick: this.hideDrawer },
                react_1.default.createElement(hamburger_1.Close, { width: "18px", color: colors_1.granite.base, cropped: true })),
            customHeader));
        const drawerFooter = footer && (react_1.default.createElement("div", { className: "drawer-footer", style: footerStyle }, footer));
        // don't allow any other values
        const drawerPosition = position || 'right';
        const drawerNode = (react_1.default.createElement(react_dock_1.default, Object.assign({ fluid: autoResize, size: size, position: drawerPosition, isVisible: show, dimMode: "opaque", zIndex: zIndex, dimStyle: { background: 'rgba(0, 0, 0, 0.5)' }, onVisibleChange: this.handleVisibleChange }, rest),
            react_1.default.createElement("div", { className: emotion_1.cx('drawer-content', className), style: style },
                drawerHeader,
                react_1.default.createElement("div", { className: "drawer-body", style: bodyStyle }, children),
                drawerFooter)));
        return react_dom_1.default.createPortal(drawerNode, document.body);
    }
}
exports.default = Drawer;
Drawer.propTypes = {
    show: prop_types_1.default.bool.isRequired,
    position: prop_types_1.default.oneOf(['left', 'right', 'top', 'bottom']),
    autoResize: prop_types_1.default.bool,
    size: prop_types_1.default.number,
    header: prop_types_1.default.node,
    footer: prop_types_1.default.node,
    children: prop_types_1.default.node,
    closeOnClickOutside: prop_types_1.default.bool,
    onRequestHide: prop_types_1.default.func,
    headerStyle: react_style_proptype_1.default,
    footerStyle: react_style_proptype_1.default,
    bodyStyle: react_style_proptype_1.default,
    style: react_style_proptype_1.default,
    className: prop_types_1.default.string,
    zIndex: prop_types_1.default.number,
};
Drawer.defaultProps = {
    position: 'right',
    autoResize: true,
    size: 0.3,
    zIndex: 1040,
};
